/*
 * Layout-Manager fieldHandlers definitions
 *
 * version 0.1.0
 *
 * Kosmos
 *
 * Files below need to be referenced in the calling page for the component to run correctly :
 *
 * 	JS :
 * 	- jQuery ( jquery-XX.XX.XX.js )
 *  - layoutManager ( jquery.layout-manager-XX.XX.XX.js )
 *
 * Versions :
 *
 * 0.1.0 :
 *  - Field handlers creation
 *
 */
(function ($) {
    'use strict';

    $.layoutManagerHandlers.registerFieldHandler(
        [
            {
                name: 'ckToolbox',
                selector: '.js-ckeditor',
                edit: function (field, card) {
                    const $field = $(field);
                    $field.val(card.model[$field.attr('name')]);
                    return true;
                },
                save: function (field, card) {
                    const $field = $(field);
                    const fieldName = $field.attr('name');
                    const editor = CKEDITOR.instances[fieldName];
                    if (editor && card.model.hasOwnProperty(fieldName)) {
                        editor.updateElement();
                        card.model[fieldName] = $field.val();
                        return true;
                    }
                    return false;
                }
            },
            {
                name: 'kMonoSelect',
                selector: '.kmonoselect',
                edit: function (field, card) {
                    if (field) {
                        const $component = $(field);
                        const $libelle = $('input[type="hidden"][name^="LIBELLE_"]', $component);
                        const name = $libelle.attr('name').replace('LIBELLE_', '');
                        const $code = $('#' + name, $component);
                        const splitedValue = card.model[name] ? card.model[name].split('|') : ['', ''];
                        $component.kMonoSelect().clear();
                        $code.val(splitedValue[0]);
                        $libelle.val(splitedValue[1]);
                        $component.kMonoSelect().value(splitedValue[1], splitedValue[0]);
                        return true;
                    }
                    return false;
                },
                save: function (field, card) {
                    if (field) {
                        const $component = $(field);
                        const $libelle = $('input[type="hidden"][name^="LIBELLE_"]', $component);
                        const name = $libelle.attr('name').replace('LIBELLE_', '');
                        const $code = $('#' + name, $component);
                        card.model[name] = $code.val() && $libelle.val() ? $code.val() + '|' + $libelle.val() : null;
                        return true;
                    }
                    return false;
                }
            },
            {
                name: 'kMultiSelect',
                selector: '.kmultiselect-ttl, .kmultiselect-ltl',
                edit: function (field, card) {
                    if (field) {
                        const $component = $(field);
                        const $compositionList = $('.kmultiselect-composition-list', $component);
                        const $libelles = $('input[name^="LIBELLE_"]', $component);
                        const name = $libelles.attr('name').replace('LIBELLE_', '');
                        const $input = $('#' + name, $component);
                        $input.val('');
                        $libelles.val('');
                        const $parentList = $('.kmultiselect-parent-list', $component);
                        if ($parentList && $compositionList[0]) {
                            // Vide la liste "composition" des éléments sélectionnés en récupèrant ces éléments.
                            const childrenComposition = $compositionList[0].children;
                            if (childrenComposition) {
                                $.each(childrenComposition, function (index, compoChild) {
                                    // Remplace les classes des éléments sélectionnés par les classes des éléments sélectionnables. Permet d'afficher le symbole (+).
                                    compoChild.classList.remove(...compoChild.classList);
                                    compoChild.classList.add('ui-state-default', 'kmultiselect-parent-list-row', 'kconnected-sortable', 'draggable');
                                    const libelle = compoChild.getElementsByClassName('composition-list-label');
                                    if (libelle && libelle[0]) {
                                        const spanLabel = document.createElement('span');
                                        spanLabel.classList.add('parent-list-label');
                                        spanLabel.textContent = libelle[0].textContent;
                                        const button = document.createElement('button');
                                        button.classList.add('ui-button', 'ui-widget', 'ui-state-default', 'ui-corner-all', 'ui-button-icon-only', 'klist-button');
                                        button.setAttribute('aria-disabled', 'false');
                                        const plusButton = document.createElement('span');
                                        plusButton.classList.add('ui-button-icon-primary', 'ui-icon', 'ui-icon-plusthick');
                                        const libelleButton = document.createElement('span');
                                        libelleButton.classList.add('ui-button-text');
                                        button.appendChild(plusButton);
                                        button.appendChild(libelleButton);
                                        compoChild.replaceChildren(spanLabel, button);
                                    }
                                });
                                // Ajoute les éléments de la liste "composition" à la liste "parent" des éléments sélectionnables.
                                $parentList.append(childrenComposition);
                            }
                            const listChildren = $('.kmultiselect-parent-list-row', $parentList).toArray();
                            sortListByField(listChildren, 'title');
                            $parentList.append(listChildren);
                        }
                        if (card.model[name]) {
                            $.each(card.model[name].split(';'), function (index, value) {
                                const pattern = /([\w\-_.@]+)(,LANGUE=([0-9]))?(,TYPE=[\w\-]+)?,(.+)/;
                                const match = pattern.exec(value);

                                const ignore = match[1].lastIndexOf('#AUTO#') === 0;
                                const langue = match[3] ? ',LANGUE=' + match[3] : '';
                                const type = match[4] ? match[4] : '';
                                const realValue = match[1] + langue + type;
                                $input.val($input.val() + realValue + ';');

                                const libelle = match[match.length - 1];
                                //Car le libelle est toujours le dernier du match
                                $libelles.val($libelles.val() + libelle + ';');
                                $('<li>').addClass(ignore ? 'ignore' : '').html(libelle)
                                    .attr('data-value', realValue).attr('title', libelle).appendTo($compositionList);

                                // Cas des ltl, on nettoie le côté gauche en même temps
                                if ($parentList) {
                                    $('li[data-value="' + realValue + '"]', $parentList).remove();
                                }
                            });
                            $component.kMultiSelect().update();
                            return true;
                        }
                    }
                    return false;
                },
                save: function (field, card) {
                    if (field) {
                        const $component = $(field);
                        const $libelles = $('input[name^="LIBELLE_"]', $component);
                        const name = $libelles.attr('name').replace('LIBELLE_', '');
                        const $input = $('#' + name, $component);
                        const libelles = $.cleanArray($libelles.val().split(';'));
                        const values = $.cleanArray($input.val().split(';'));
                        const joinedValues = [];
                        if (libelles.length > 0) {
                            $.each(
                                values, function (index, value) {
                                    joinedValues.push(value + ',' + libelles[index]);
                                });
                            card.model[name] = joinedValues.join(';');
                            return true;
                        } else {

                            card.model[name] = null;
                        }
                    }
                    return false;
                }
            },
            {
                name: 'media-component',
                selector: 'input[name].js-media-component__id-ressource',
                edit: function (field, card) {
                    const $input = $(field);
                    $input.val(card.model[$input.attr('name')] ? JSON.stringify(card.model[$input.attr('name')]) : '');
                    $input.closest('.js-media-component').mediaComponent().refresh();
                    return true;
                },
                save: function (field, card) {
                    const $input = $(field);
                    if (card.model.hasOwnProperty($input.attr('name'))) {
                        card.model[$input.attr('name')] = $input.val() ? JSON.parse($input.val()) : null;
                        return true;
                    }
                    return false;
                }
            },
            {
                name: 'select',
                selector: 'select',
                edit: function (field, card) {
                    const $select = $(field);
                    $select.val(card.model[$select.attr('name')] ? card.model[$select.attr('name')] : '');
                    return true;
                },
                save: function (field, card) {
                    const $select = $(field);
                    if (card.model.hasOwnProperty($select.attr('name'))) {
                        card.model[$select.attr('name')] = $select.val() ? $select.val() : null;
                        return true;
                    }
                    return false;
                }
            },
            {
                name: 'textarea',
                selector: 'textarea',
                edit: function (field, card) {
                    const $input = $(field);
                    $input.val(card.model[$input.attr('name')] ? card.model[$input.attr('name')] : '');
                    return true;
                },
                save: function (field, card) {
                    const $input = $(field);
                    if (card.model.hasOwnProperty($input.attr('name'))) {
                        card.model[$input.attr('name')] = $input.val() ? $input.val() : null;
                        return true;
                    }
                    return false;
                }
            },
            {
                name: 'radio',
                selector: 'input[type="radio"]',
                edit: function (field, card) {
                    const $input = $(field);
                    $input.prop('checked', $input.val() === card.model[$input.attr('name')]);
                    return true;
                },
                save: function (field, card) {
                    const $input = $(field);
                    if (card.model.hasOwnProperty($input.attr('name'))) {
                        if ($input.is(':checked')) {
                            card.model[$input.attr('name')] = $input.val() ? $input.val() : null;
                        }
                        return true;
                    }
                    return false;
                }
            },
            {
                name: 'checkbox',
                selector: 'input[type="checkbox"]',
                edit: function (field, card) {
                    const $input = $(field);
                    const name = $input.attr('name');
                    const hasMultipleValues = $('input[type="checkbox"][name="' + name + '"]', $input.parents('[data-card-class="' + card.model.class + '"]')).length > 1;
                    const isArray = $.isArray(card.model[name]) || hasMultipleValues;
                    let values;
                    let valuesArray;
                    if (isArray) {
                        valuesArray = card.model[name] || [];
                    } else {
                        values = card.model[name];
                    }
                    $input.prop('checked', isArray ? valuesArray.indexOf($input.val()) !== -1 : values);
                    return true;
                },
                save: function (field, card) {
                    const $input = $(field);
                    const name = $input.attr('name');
                    if (card.model.hasOwnProperty(name)) {
                        const hasMultipleValues = $('input[type="checkbox"][name="' + name + '"]',
                            $input.parents('[data-card-class="' + card.model.class + '"]')).length > 1;
                        const isArray = $.isArray(card.model[name]) || hasMultipleValues;
                        if (isArray) {
                            const valuesArray = card.model[name] || [];
                            if ($input.is(':checked')) {
                                if (valuesArray.indexOf($input.val()) === -1) {
                                    valuesArray.push($input.val());
                                }
                            } else {
                                const index = valuesArray.indexOf($input.val());
                                if (index !== -1) {
                                    valuesArray.splice(index);
                                }
                            }
                            card.model[name] = valuesArray;
                        } else {
                            card.model[name] = $input.is(':checked');
                        }
                        return true;
                    }
                    return false;
                }
            },
            {
                name: 'generic',
                selector: 'input[name]:not([type="hidden"])',
                edit: function (field, card) {
                    const $input = $(field);
                    $input.val(card.model[$input.attr('name')] ? card.model[$input.attr('name')] : '');
                    return true;
                },
                save: function (field, card) {
                    const $input = $(field);
                    if (card.model.hasOwnProperty($input.attr('name'))) {
                        card.model[$input.attr('name')] = $input.val() ? $input.val() : null;
                        return true;
                    }
                    return false;
                }
            }
        ]);

    function sortListByField(list, field) {
        list.sort((a ,b) => {
            const aField = a[field].toLocaleLowerCase();
            const bField = b[field].toLocaleLowerCase();
            if (aField > bField) {
                return 1;
            }
            if (aField < bField) {
                return -1;
            }
            return 0;
        });
    }

})(jQuery);
